import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "color-trend-detail" */ './index')
);
